import { configurationApi } from '../configurationApi';
import { PhysicianType } from '../types/physicianType';
import { GetPhysiciansRequest } from '../requests/getPhysiciansRequest';

interface UploadResponse {
  successful: number;
  failed: number;
  errors: string[];
  isSuccess: boolean;
  errorMessage: string;
}

const physicianEndpoints = configurationApi.injectEndpoints({
  endpoints: (builder) => ({
    getPhysicians: builder.query<PhysicianType[], GetPhysiciansRequest>({
      query: ({ company, center }) =>
        `/Physicians?CompanyId=${encodeURIComponent(company)}&CenterId=${encodeURIComponent(center)}`,
      providesTags: ['Physicians'],
    }),

    updatePhysician: builder.mutation<PhysicianType, PhysicianType>({
      query: (physician) => ({
        url: '/Physician',
        method: 'POST',
        body: physician,
      }),
      invalidatesTags: ['Physicians'],
    }),

    uploadPhysicians: builder.mutation<
      UploadResponse,
      { company: string; centerId: string; file: File }
    >({
      query: ({ company, centerId, file }) => {
        const formData = new FormData();
        formData.append('file', file);

        return {
          url: `Company/${company}/Center/${centerId}/Physicians/Upload`,
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: ['Physicians'],
    }),

    downloadPhysicians: builder.mutation<Blob, { company: string; centerId: string }>({
      query: ({ company, centerId }) => ({
        url: `Company/${company}/Center/${centerId}/Physicians/Download`,
        method: 'GET',
        responseHandler: (response) => response.blob(),
      }),
    }),

    getSpecialties: builder.query<{ name: string; value: string }[], void>({
      query: () => '/Specialties',
    }),

    getPhysiciansByCompany: builder.query<PhysicianType[], { company: string }>({
      query: ({ company }) => `/Physicians/ByCompany?company=${encodeURIComponent(company)}`,
      providesTags: ['Physicians'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetPhysiciansQuery,
  useGetPhysiciansByCompanyQuery,
  useUpdatePhysicianMutation,
  useUploadPhysiciansMutation,
  useDownloadPhysiciansMutation,
  useGetSpecialtiesQuery,
} = physicianEndpoints;
